export const PERMISSION_MODULES = [
  'tournaments',
  'matches',
  'scoring',
  'reports',
  'sponsors',
  'grounds',
  'settings',
];

export const ROUTE_PERMISSIONS = {
  dashboard: { anyRead: true },
  tournaments: { module: 'tournaments', action: 'read' },
  teams: { module: 'tournaments', action: 'read' },
  players: { module: 'tournaments', action: 'read' },
  matches: { module: 'matches', action: 'read' },
  grounds: { module: 'grounds', action: 'read' },
  gallery: { module: 'sponsors', action: 'read' },
  sponsors: { module: 'sponsors', action: 'read' },
  reports: { module: 'reports', action: 'read' },
  settings: { module: 'settings', action: 'read' },
  notifications: { module: 'settings', action: 'read' },
  scorer: { module: 'scoring', action: 'read' },
  settingsUsers: { module: 'settings', action: 'write' },
  settingsRoles: { module: 'settings', action: 'write' },
};

export function hasModulePermission(permissions, module, action) {
  if (!permissions || !module || !action) return false;
  return Boolean(permissions?.[module]?.[action]);
}

export function hasAnyReadPermission(permissions) {
  if (!permissions) return false;
  return PERMISSION_MODULES.some((module) => hasModulePermission(permissions, module, 'read'));
}

export function checkRoutePermission(permissions, routePermission) {
  if (!routePermission) return true;
  if (routePermission.anyRead) return hasAnyReadPermission(permissions);
  return hasModulePermission(permissions, routePermission.module, routePermission.action);
}
